module.exports = __webpack_public_path__ + "static/media/loginPage.700081f9.jpeg";